import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, Button, Container, FormControl, FormHelperText, IconButton, InputAdornment, Paper, TextField } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../components/Header';
import Loading from '../components/Loading';
import { setHeader } from '../features/headerSlice';
import { postlogin } from '../services/ApiService';
import { LoginPostRequest } from '../services/dto/loginDto';

const SCREEN = 'login';

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { chainUid, unitUid, acctNo, password } = useParams();
  const [inpPassword, setInpPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setLoading(true);

    dispatch(setHeader({
      chainUid: chainUid ?? '',
      unitUid: unitUid ?? '',
      acctNo: acctNo ?? '',
    }));

    setInpPassword(password ?? '');

    // デフォルトヘッダー設定
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    axios.defaults.headers.common['X-Chain-Uid'] = chainUid;
    axios.defaults.headers.common['X-Unit-Uid'] = unitUid;
    axios.defaults.headers.common['X-Acct-No'] = acctNo;

    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInpPassword(event.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async () => {
    setLoading(true);

    const request: LoginPostRequest = {
      password: inpPassword,
    };

    try {
      const res = await postlogin(request);
      if (res.data === 0) {
        navigate("/input");
      } else if (res.data === 1) {
        navigate("/complete");
      } else {
        setError('Password is invalid');
      }
    } catch (error) {
      console.error('error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs">
      <Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
        <Header title={t(`${SCREEN}.title`)} />
        <Loading open={loading} />
        <Box mt={2}>
          <FormControl fullWidth error={!!error}>
            <TextField
              label={t(`${SCREEN}.password`)}
              type={showPassword ? 'text' : 'password'}
              value={inpPassword}
              onChange={handlePasswordChange}
              fullWidth
              variant="outlined"
              margin="normal"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={togglePasswordVisibility}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            {error && (
              <FormHelperText>{error}</FormHelperText>
            )}
          </FormControl>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            fullWidth
            style={{ marginTop: '1rem' }}
          >
            {t(`${SCREEN}.next`)}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default Login;
